import { NavLink, useNavigate } from 'react-router-dom';
import { useBreakpoint } from '@chakra-ui/react';
import { Button } from '@chakra-ui/button';
import { useColorMode, useColorModeValue } from '@chakra-ui/color-mode';
import { Box, HStack, Text } from '@chakra-ui/layout';
import { MoonIcon, SunIcon } from '@chakra-ui/icons';
import { MOBILE_DEVICES, ROUTES } from '../utils/constants';

const Header = () => {
	const { colorMode, toggleColorMode } = useColorMode();
	const navMenuColor = useColorModeValue('#000', '#fff');
	const breakpoint = useBreakpoint();
	const isMobile = MOBILE_DEVICES.includes(breakpoint);
	const navigate = useNavigate();

	const navigateHome = () => {
		if (isMobile) {
			document.getElementById('about').scrollIntoView({ behavior: 'smooth' });
		} else {
			navigate('/');
		}
	}

	return (
		<Box
			p='5'
			background={useColorModeValue('gray.300', 'gray.900')}
			shadow='lg'
			borderRadius='lg'
			position='relative'
			zIndex='1000'
			width='100%'
		>
			<HStack justifyContent={{ base: 'space-between' }}>
				<Box cursor='pointer' onClick={navigateHome}>
					<Text>&lt;Trey Burleson /&gt;</Text>
				</Box>

				<HStack>
					<HStack
						as='nav'
						display={{ base: 'none', md: 'block' }}
						spacing='10'
					>
						{ROUTES.map(({ to, label }) => (
							<Text
								as={NavLink}
								to={to}
								letterSpacing={{ md: '2px', lg: '4px' }}
								style={({ isActive }) => ({
									color: isActive ? navMenuColor : '#858585',
								})}
								fontSize="large"
								key={label}
								_hover={{
									fontSize: "xl",
									transition: "0.2s ease-in",
								}}
								transition="0.4s ease-out"
							>
								{label}
							</Text>
						))}
					</HStack>
				</HStack>

				<Button className='colorButton' p={2} onClick={toggleColorMode}>
					{colorMode === 'light' ? <MoonIcon /> : <SunIcon />}
				</Button>
			</HStack>
		</Box>
	);
};

export default Header;